





















































































































import { Component, Vue } from "vue-property-decorator";
import AppPrompt from "@/components/AppPrompt.vue";
import Header from "@/components/Header.vue";
import SlowVideoBox from "@/components/slow/SlowVideoBox.vue";
import Gift from "@/components/Gift.vue";
import Footer from "@/components/Footer.vue";
import ChatRoomItem from "@/components/ChatRoomItem.vue";
import LiveRoomItem from "@/components/LiveRoomItem.vue";
import Suspension from "@/components/Suspension.vue";
import GiftTips from "@/components/GiftTips.vue";
import request from "@/api/index";
import native from "@/common/Native";
import { Tab, Tabs, List } from "vant";
import {
  IChatRoomItem,
  IDetail,
  IGiftItem,
  IGiftTipsItem,
  ILiveRoomItem,
  IShareInfo
} from "@/api/types";
import { needToken } from "@/common/decorator";
import {
  recordCount,
  recordTime,
  removRecordTime,
  removRecordVideo
} from "@/api/dataCollect";

interface ITabItem {
  title: string;
  icon: string;
  activeIcon: string;
  loading: boolean;
  finished: boolean;
  onLoad: Function;
}
@Component({
  components: {
    AppPrompt,
    Header,
    SlowVideoBox,
    ChatRoomItem,
    LiveRoomItem,
    Gift,
    Footer,
    Suspension,
    GiftTips,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List
  }
})
export default class Home extends Vue {
  detail: IDetail | null = null;
  showGift = false;
  shareInfo: IShareInfo | null = null;
  giftList: IGiftItem[] = [];
  chatRoomList: IChatRoomItem[] = [];
  liveRoomList: ILiveRoomItem[] = [];
  barrageList: IChatRoomItem[] = [];
  giftTips: IGiftTipsItem[] = [];
  showBarrage = true;
  showBarrageName = false;
  tabList: ITabItem[] = [
    {
      title: "直播间",
      icon: "",
      activeIcon: "",
      loading: false,
      finished: false,
      onLoad: () => {
        this.getLiveRoom("load");
      }
    },
    {
      title: "聊天室",
      icon: "",
      activeIcon: "",
      loading: false,
      finished: false,
      onLoad: this.getChatRoomList
    }
  ];
  isOpenApp = false;
  active = 0;
  liveRoomSort = "";
  taskTimer = 0;
  bgAudioList: { url: string; ids: number[] }[] = [];
  switchAudio = true; // 音频开关
  isAudio = true;

  // 是否静音
  liveMute: number | null = null;

  get isShowHeader() {
    if (!native.isOpenInApp() || native.getOS() === "iOS") {
      return false;
    }
    return true;
  }
  get hideDetailViewCount() {
    return this.$store.state.hideDetailViewCount;
  }

  get playStatus() {
    const status = this.detail ? this.detail.status : 0;
    let statusText = "";
    switch (+status) {
      case 0:
        statusText = "待开始";
        break;
      case 1:
        statusText = "正在直播";
        break;
      case 2:
        statusText = "已结束";
        break;
      default:
        break;
    }
    return statusText;
  }

  get liveRoomSortIcon() {
    if (this.liveRoomSort === "DESC") {
      return require("../assets/image/降序@2x.png");
    } else {
      return require("../assets/image/升序@2x.png");
    }
  }

  get liveRoomSorttext() {
    if (this.liveRoomSort === "DESC") {
      return "按时间降序";
    } else {
      return "按时间升序";
    }
  }

  get activeItem() {
    return this.tabList[this.active];
  }

  get appId() {
    return this.$store.state.appId;
  }

  get infoClassifyId() {
    return this.$store.state.infoClassifyId;
  }

  get appIdFromUA() {
    return this.$store.state.appIdFromUA;
  }

  get infoSynopsis() {
    if (this.$store.state.appId != 1) {
      return this.detail?.synopsis || "";
    }

    if (this.detail && this.detail.synopsis) {
      const strArr = this.detail.synopsis.split("\r\n");
      const newStrArr = strArr.map(item => {
        return `<p>${item}</p>`;
      });
      return newStrArr.join("");
    } else {
      return "";
    }
  }

  async mounted() {
    this.$store.commit("SET_STATE", {
      infoClassifyId: this.$route.query.id
      // infoClassifyId: 5359647
    });

    // 2957392 3004391
    if (!native.isOpenInApp()) {
      await this.addViewCount();
    }

    await this.getDetail();
  }

  /** 底部分享按钮 */
  footerShareClick() {
    native.shareApp();
  }
  init() {
    // 是否展示直播间
    if (!this.detail!.isShowLiveRoom) {
      this.tabList.splice(
        this.tabList.findIndex(item => item.title === "直播间"),
        1
      );
    }
    // 是否展示聊天室
    if (!this.detail!.isShowChat) {
      this.tabList.splice(
        this.tabList.findIndex(item => item.title === "聊天室"),
        1
      );
    }
    // 动态配置直播间和聊天室的icon
    this.tabList.forEach(item => {
      if (item.title === "直播间") {
        item.icon =
          this.detail!.liveRoomDarkIcon ||
          require("../assets/image/直播间icon（未选中）@2x.png");
        item.activeIcon =
          this.detail!.liveRoomIcon ||
          require("../assets/image/直播间icon（选中）@2x.png");
      } else {
        item.icon =
          this.detail!.chatDarkIcon ||
          require("../assets/image/聊天室icon（未选中）@2x.png");
        item.activeIcon =
          this.detail!.chatIcon ||
          require("../assets/image/聊天室icon（选中）@2x.png");
      }
    });
    this.isOpenApp = !native.isOpenInApp();
    // 是否展示弹幕
    this.showBarrage = this.detail!.isShowBulletScreen === 1;
    this.showBarrageName = this.detail!.isShowBulletScreenName === 1;
    if (localStorage.getItem("barrageStatus") === "false") {
      this.showBarrage = false;
    }
    this.getLiveShareInfo();
    if (native.isOpenInApp()) {
      native.setBottomBar().then(() => {});
      // if (this.isShowHeader) {
      //   native.setTopBar();
      // }
    }
    if (this.detail!.isShowLiveRoom) {
      this.getLiveRoom("mounted");
    }
    if (this.detail!.isShowChat) {
      this.getChatRoomList();
    }
    if (this.$route.query.id != "96807269") {
      this.getGiftList();
    }
    this.getShareInfo();
    this.getLiveReply();
    this.taskList();
  }
  /**
   * 音频控制器
   */
  audioControl() {
    this.switchAudio = !this.switchAudio;
  }
  /** 端外增加浏览量 */
  addViewCount() {
    // request
    //   .getCount(this.infoClassifyId, process.env.VUE_APP_COUNT_API)
    //   .then(() => {});
    request.getCount().then(() => {});
  }

  getImg(item: ITabItem, index: number) {
    if (index === this.active) {
      return item.activeIcon;
    } else {
      return item.icon;
    }
  }

  async getAppConfig() {
    const result = await request.getAppConfig();
    if (result) {
      for (let i = 0; i < result.length; i++) {
        if (result[i].appId == this.appId) {
          this.liveMute = result[i].appConfig.liveMute ?? 1;
          this.$store.commit("SET_STATE", {
            hideDetailViewCount: result[i].appConfig.hideDetailViewCount
          });
          break;
        }
      }
    }
  }

  @needToken(false)
  async getDetail() {
    const result = await request.getSlowDetailApi(this.infoClassifyId);
    if (result.code === 0) {
      this.detail = result.data;
      recordCount({ news: this.detail, sourceType: "news" });
      recordTime({ news: this.detail, sourceType: "news" });
      document.title = this.detail.title;
      const audioNotNullList = result.data.cameraLensList!.filter(
        item => !!item.audioUrl
      );
      const audioList: { url: string; ids: number[] }[] = [];
      audioNotNullList.forEach(item => {
        if (audioList.length <= 0) {
          audioList.push({
            url: item.audioUrl,
            ids: [item.id]
          });
          return;
        }
        const index = audioList.findIndex(
          audioItem => audioItem.url === item.audioUrl
        );
        if (index != -1) {
          audioList[index].ids.push(item.id);
        } else {
          audioList.push({
            url: item.audioUrl,
            ids: [item.id]
          });
        }
      });
      console.log(audioList);

      this.bgAudioList = audioList;
      this.$store.commit("SET_STATE", {
        detail: result.data,
        appId: result.data.appId || "1"
      });
      this.getAppConfig();
      this.init();
    }
  }

  async getLiveShareInfo() {
    if (native.isOpenInApp()) {
      const { data } = await request.liveShare(this.infoClassifyId);
      native.setShareConfig({
        id: this.infoClassifyId + "",
        title: data.shareTitle,
        content: data.synopsis,
        icon: data.shareImgUrl,
        url: data.shareUrl,
        sourceType: data.sourceType + ""
      });

      native.registerShareConfig({
        id: this.infoClassifyId + "",
        shareTitle: data.shareTitle,
        shareDescription: data.synopsis,
        shareImgUrl: data.shareImgUrl,
        shareUrl: data.shareUrl,
        sourceType: data.sourceType + "",
        shareUrlQQ: data.shareUrl,
        shareUrlQzone: data.shareUrl,
        shareUrlWx: data.shareUrl,
        shareUrlWxMoments: data.shareUrl,
        shareUrlWeibo: data.shareUrl
      });
    }
  }

  footerClick(text: string, value?: boolean) {
    new Map([
      [
        "gift",
        () => {
          this.showGift = true;
        }
      ],
      [
        "zan",
        async () => {
          const result = await request.doPraise(
            "",
            this.detail!.title,
            this.detail!.informationId,
            0,
            1
          );
          if (result.data) {
            /** showPraiseCount 在没上万的时候和praiseCount数值一致 */
            if (
              this.detail!.showPraiseCount ===
              this.detail!.praiseCount + ""
            ) {
              this.detail!.showPraiseCount = String(
                this.detail!.praiseCount + 1
              );
              this.detail!.praiseCount += 1;
            }
            this.detail!.isPraise = true;
          }
        }
      ],
      [
        "share",
        () => {
          native.shareApp();
        }
      ],
      [
        "barrage",
        () => {
          this.showBarrage = value!;
        }
      ]
    ]).get(text)!();
  }

  async getGiftList() {
    const result = await request.giftList();
    if (result.code === 0) {
      this.giftList = result.data.pageResults;
    }
  }

  async getShareInfo() {
    const result = await request.getShareInfo();
    if (result.code === 0) {
      this.shareInfo = result.data;
      this.$store.commit("SET_STATE", {
        downloadUrl: result.data.downloadUrl
      });
    }
  }

  /** 获取直播间列表 */
  @needToken(false)
  async getLiveRoom(tag?: string) {
    console.log(tag);
    const lastItem = this.liveRoomList.lastChild || { id: "" };
    const result = await request.getLiveRoom(
      this.infoClassifyId,
      lastItem.compereId,
      lastItem.id,
      lastItem.sortNo,
      lastItem.createTime,
      [],
      this.liveRoomSort
    );
    console.log("直播间列表数据", result.data);
    if (result.code == 0 && this.liveRoomSort == "") {
      if (result.message) {
        this.liveRoomSort = result.message;
      } else {
        this.liveRoomSort = "DESC";
      }
    }
    const cureent = this.tabList[this.active];
    if (!result.data || result.data.length === 0) {
      cureent.finished = true;
    } else {
      this.liveRoomList = this.liveRoomList.concat(result.data);
    }
    if (tag === "sort" || tag === "mounted") {
      this.tabList.find(item => item.title === "直播间")!.finished = false;
    }
    cureent.loading = false;
  }

  /** 获取聊天室列表 */
  @needToken(false)
  async getChatRoomList() {
    const lastItem = this.chatRoomList.lastChild || {};
    const result = await request.getChatRoom(
      this.infoClassifyId,
      lastItem.createTime,
      lastItem.id
    );
    const cureent = this.tabList[this.active];
    if (!result.data || result.data.length === 0) {
      cureent.finished = true;
    } else {
      cureent.loading = false;
      this.chatRoomList = this.chatRoomList.concat(result.data);
    }
  }

  @needToken(false)
  async addLiveRoom() {
    if (this.liveRoomSort === "ASC") {
      return;
    }
    const firstItem = this.liveRoomList[0] || { id: "" };
    const result = await request.getLiveRoom(
      this.infoClassifyId,
      firstItem.compereId,
      firstItem.id,
      firstItem.sortNo,
      firstItem.createTime,
      [],
      "ASC"
    );
    if (result.data && result.data.length > 0) {
      result.data.forEach(item => {
        this.liveRoomList.unshift(item);
      });
    }
  }

  @needToken(false)
  async addChatRoom() {
    const result = await request.getChatRoom(
      this.infoClassifyId,
      "",
      undefined
    );
    if (result.data && result.data.length > 0) {
      // 将已点赞的数据同步到新加的数据中
      result.data.forEach(item => {
        const i = this.chatRoomList.find(i => i.id === item.id);
        if (i) {
          item.isPraise = i.isPraise;
        }
      });
      const { length } = result.data;
      // 处理最新页不满10条的特殊情况
      if (length < 10) {
        this.chatRoomList = result.data;
      } else {
        this.chatRoomList.splice(0, length);
        this.chatRoomList = result.data.concat(this.chatRoomList);
      }
    }
  }

  doPraise(id: number, type: 1 | 2) {
    if (type === 1) {
      const item = this.liveRoomList.find(item => item.id === id)!;
      item.isPraise = true;
      item.praiseCount += 1;
    } else {
      const item = this.chatRoomList.find(item => item.id === id)!;
      item.isPraise = true;
      item.praise += 1;
    }
  }

  /** 设置直播间评论升序降序排列 */
  setSort() {
    // this.tabList.find(item => item.title === "直播间")!.finished = false;
    this.liveRoomSort = this.liveRoomSort === "DESC" ? "ASC" : "DESC";
    this.liveRoomList = [];
    this.getLiveRoom("sort");
  }

  async getLiveReply(isAdd = false) {
    const lastItem = this.barrageList.lastChild || {};
    const result = await request.liveReply(this.infoClassifyId, lastItem.id);
    if (result.code === 0) {
      if (isAdd) {
        this.barrageList = this.barrageList.concat(result.data);
      } else {
        this.barrageList = result.data;
      }
    }
  }

  async getGiftTips() {
    const result = await request.giftTips(
      this.detail!.informationId,
      this.detail?.pollTime || 8000
    );
    if (result.code === 0) {
      this.giftTips = this.giftTips.concat(result.data);
    }
  }

  removeList(length: number) {
    if (this.barrageList.length > 50) {
      this.barrageList.splice(0, this.barrageList.length - length);
    }
  }

  removeGiftTips(length: number) {
    this.giftTips.splice(0, this.giftTips.length - length);
  }

  taskList() {
    const time = this.detail?.pollTime || 8000;
    this.taskTimer = setInterval(() => {
      this.getLiveReply(true);
      if (this.$route.query.id != "96807269") {
        this.getGiftTips();
      }
      if (this.detail!.isShowLiveRoom) {
        this.addLiveRoom();
      }
      if (this.detail!.isShowChat) {
        this.addChatRoom();
      }
    }, time);
  }

  beforeDestroy() {
    clearInterval(this.taskTimer);
    removRecordTime();
    removRecordVideo();
  }
}
